// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Courses from "./pages/Courses";
import ScrollToTop from "./ScrollToTop.jsx";
import LoadingScreen from "./components/LoadingScreen";
import Services from "./pages/services.jsx";
// import CustomCursor from "./components/CustomCursor"; // Import CustomCursor
import AOS from "aos";
import "aos/dist/aos.css";
// import PdfViewer from "./components/Pdfveiwer.jsx";
import Notes from "./components/Notes.jsx";
import QnA from "./components/QnA.jsx";
import Books from "./components/Books.jsx";
import Fee from "./pages/Fee.jsx";
import OnlineTest from "./components/TopList.jsx";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => setIsLoading(false), 1000); // 1000ms = 1 second for fade-out
    }, 1700); // 3000ms = 3 seconds for initial loading

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen fadeOut={fadeOut} />;
  }

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/Notes" element={<Notes />} />
            <Route path="/services/QnA" element={<QnA />} />
            <Route path="/services/books" element={<Books />} />
            <Route path="/fees" element={<Fee />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/view-pdf/:url" component={PdfViewer} /> */}
            <Route path="/services/online-test" element={<OnlineTest />} />
          </Routes>
        </main>
        <Footer />
        {/* <CustomCursor /> Add the CustomCursor component here */}
      </div>
    </Router>
  );
}

export default App;
